import React from 'react';
import styled from 'styled-components';

import { CommonContainerStyle } from '../../styles';
import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

export const CardBodyBottomSectionLoadingUI = () => {
    return (
        <Container>
            <DetailLiItem key='card-body-bottom-section-animated-loading-ui-0' hasBackgroundColor={true}>
                <AnimatedLoadingPlaceholder key='humidity-label' width={80} height='70%' />
                <AnimatedLoadingPlaceholder key='humidity-value' width={60} height='70%' />
            </DetailLiItem>
            <DetailLiItem key='card-body-bottom-section-animated-loading-ui-1' hasBackgroundColor={false}>
                <AnimatedLoadingPlaceholder key='wind-label' width={80} height='70%' />
                <AnimatedLoadingPlaceholder key='wind-value' width={60} height='70%' />
            </DetailLiItem>
            <DetailLiItem key='card-body-bottom-section-animated-loading-ui-2' hasBackgroundColor={true}>
                <AnimatedLoadingPlaceholder key='dewpoint-label' width={80} height='70%' />
                <AnimatedLoadingPlaceholder key='dewpoint-value' width={60} height='70%' />
            </DetailLiItem>
        </Container>
    );
};

const Container = styled.ul`
    ${CommonContainerStyle}
    padding: 0;
    height: calc(100% - 142px);
`;

interface ContainerProps {
    hasBackgroundColor: boolean;
}

const DetailLiItem = styled.li<ContainerProps>`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    padding: 0 15px;
    height: 26px;
    align-items: flex-start;
    ${({ hasBackgroundColor }) => hasBackgroundColor && `
        background-color: #f1f1f1;
    ` }
`;